import { accountRequestStatusEnum } from '@/constants/user'

export function isPendingAccountByApex(account) {
  return ![
    accountRequestStatusEnum.SUSPENDED,
    accountRequestStatusEnum.ACTION_REQUIRED,
    accountRequestStatusEnum.REJECTED,
    accountRequestStatusEnum.COMPLETE,
  ].includes(account.accountRequestStatus)
}
